<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
      <div class="background-image"></div>
  </section>

  <div class="intro2">

    <div class="container">
      <h4 class="sub-title"> الاخصائيين و الاستشاريين <span> العاملين معنا </span> </h4>
    </div>

    <!-- WorkersWithUs -->
    <div class="container">
      <div class="WorkersWithUs">
        <h3 class="text-center heading-title my-4 text-site-color borderAfter"><span class="text-dark"> فى </span> {{subSpeciality}}</h3>

        <div class="row justify-content-around pt-3">
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="box">

              <div class="flex justfy-center">
                <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit">
              </div>

              <h6 class="text-center my-3 font-weight-b font-size-lg text-site-color-bright">د. حامد سلمان</h6>

              <div class="flex space-around">

                <ul class="w-list">
                  <li>
                    <i class="far fa-star"></i>
                    <span>أخصائى أول</span>
                  </li>
                  <li>
                    <i class="fas fa-user-tie"></i>
                    <span>10 سنوات خبرة</span>
                  </li>
                  <li>
                    <i class="fas fa-stethoscope"></i>
                    <span>{{subSpeciality}}</span>
                  </li>
                </ul>

                <ul class="w-list">
                  <li>
                    <i class="fas fa-male"></i>
                    <span>ذكر</span>
                  </li>
                  <li>
                    <i class="fas fa-address-book"></i>
                    <span>40 عام</span>
                  </li>
                </ul>

              </div>

              <div class="text-center">
                <button class="btn font-weight-b"> حجز موعد </button>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="box">

              <div class="flex justfy-center">
                <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit">
              </div>

              <h6 class="text-center my-3 font-weight-b font-size-lg text-site-color-bright">د. محمد عبد الله</h6>

              <div class="flex space-around">

                <ul class="w-list">
                  <li>
                    <i class="far fa-star"></i>
                    <span>أخصائى أول</span>
                  </li>
                  <li>
                    <i class="fas fa-user-tie"></i>
                    <span>8 سنوات خبرة</span>
                  </li>
                  <li>
                    <i class="fas fa-stethoscope"></i>
                    <span>{{subSpeciality}}</span>
                  </li>
                </ul>

                <ul class="w-list">
                  <li>
                    <i class="fas fa-male"></i>
                    <span>ذكر</span>
                  </li>
                  <li>
                    <i class="fas fa-address-book"></i>
                    <span>35 عام</span>
                  </li>
                </ul>

              </div>

              <div class="text-center">
                <button class="btn font-weight-b"> حجز موعد </button>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="box">

              <div class="flex justfy-center">
                <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit">
              </div>

              <h6 class="text-center my-3 font-weight-b font-size-lg text-site-color-bright">د. أحمد عبد الفتاح</h6>

              <div class="flex space-around">

                <ul class="w-list">
                  <li>
                    <i class="far fa-star"></i>
                    <span>أخصائى</span>
                  </li>
                  <li>
                    <i class="fas fa-user-tie"></i>
                    <span>خمس سنوات خبرة</span>
                  </li>
                  <li>
                    <i class="fas fa-stethoscope"></i>
                    <span>{{subSpeciality}}</span>
                  </li>
                </ul>

                <ul class="w-list">
                  <li>
                    <i class="fas fa-male"></i>
                    <span>ذكر</span>
                  </li>
                  <li>
                    <i class="fas fa-address-book"></i>
                    <span>32 عام</span>
                  </li>
                </ul>

              </div>

              <div class="text-center">
                <button class="btn font-weight-b"> حجز موعد </button>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="box">

              <div class="flex justfy-center">
                <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit">
              </div>

              <h6 class="text-center my-3 font-weight-b font-size-lg text-site-color-bright">د. سعيد النهيان</h6>

              <div class="flex space-around">

                <ul class="w-list">
                  <li>
                    <i class="far fa-star"></i>
                    <span>استشارى</span>
                  </li>
                  <li>
                    <i class="fas fa-user-tie"></i>
                    <span>16 سنة خبرة</span>
                  </li>
                  <li>
                    <i class="fas fa-stethoscope"></i>
                    <span>{{subSpeciality}}</span>
                  </li>
                </ul>

                <ul class="w-list">
                  <li>
                    <i class="fas fa-male"></i>
                    <span>ذكر</span>
                  </li>
                  <li>
                    <i class="fas fa-address-book"></i>
                    <span>42 عام</span>
                  </li>
                </ul>

              </div>

              <div class="text-center">
                <button class="btn font-weight-b"> حجز موعد </button>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4">
            <div class="box">

              <div class="flex justfy-center">
                <img src=".././../../assets/images/woman-doctor.jpg" class="img-fluid img-thumbnail-edit">
              </div>

              <h6 class="text-center my-3 font-weight-b font-size-lg text-site-color-bright">د. مريم السديس</h6>

              <div class="flex space-around">

                <ul class="w-list">
                  <li>
                    <i class="far fa-star"></i>
                    <span>أخصائى</span>
                  </li>
                  <li>
                    <i class="fas fa-user-tie"></i>
                    <span>7 سنوات خبرة</span>
                  </li>
                  <li>
                    <i class="fas fa-stethoscope"></i>
                    <span>{{subSpeciality}}</span>
                  </li>
                </ul>

                <ul class="w-list">
                  <li>
                    <i class="fas fa-male"></i>
                    <span>أنثى</span>
                  </li>
                  <li>
                    <i class="fas fa-address-book"></i>
                    <span>36 عام</span>
                  </li>
                </ul>

              </div>

              <div class="text-center">
                <button class="btn font-weight-b"> حجز موعد </button>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>

  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>

</div>


